import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  getBulkStoreStatus,
  getStoreDetails,
  resetStoreDetails,
  resetRestaurantDetails,
  resetStores,
} from '@kfc-global/react-shared/redux/Actions/StoresAction';
import {
  getBasketPayloadforQROrder,
  getDispositionTypeOnAPIFormat,
  getValueOrDefaultObject,
  isEmptyEvery,
  isEmptyObject,
  manipulateAlreadySearchedLocations,
  setSearchStoreByAtrribute as setSearchedAttributes,
  getUserType,
  goToMenuPage,
} from 'common/utilities/utils';
import { createBasketsAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import DispositionModuleForm from '../Presentation/DispositionModuleForm';
import DispositionModuleInsideModal from '../Presentation/DispositionModuleInsideModal';
import {
  modifyData,
  setAnalyticsData,
  checkCartStatus,
  checkAndRedirectToHomepage,
  orderTypeAnalyticsHandler,
} from '../DispositionUtilities/dispositionUtils';
import { UserOrderContext } from 'context/context';
import DISPOSITION_CONSTANTS from '../Constants/DispositionConstants';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { ChannelManager } from 'common/manager';
import { setLocalisationFinishAnalyticsData } from 'common/utilities/analyticsUtils';
import { setUserParams } from '@kfc-global/react-shared/redux/Actions/AppStateAction';
import {
  DINE_IN,
  DINE_IN_TEXT,
  LOCAL_STORAGE_KEYS,
  PICK_UP,
  ROUTE_URL,
  TAKEAWAY_TEXT,
} from 'common/constants/SharedConstants';
import AlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import AlertFormInsideModel from 'molecules/Alert';
import { MENU_PLP_CONSTANT_DATA } from 'common/utilities/menuPLPModulator';

import SEARCH_STORE_CONSTANTS from 'organisms/SearchStore/Constants/SearchStoreConstants';
import { FORM } from 'organisms/SearchStore/AU/Config/searchStore.config';
export const DispositionModule = props => {
  const { CURRENTLY_CLOSED, SORRY } = MENU_PLP_CONSTANT_DATA;
  // get the context from parent
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { contentData = {} } = userOrderState.dispositionStateData;
  const { deeplinkSelectedStoreId, deepLinkStoreMode, isDeepLinkURL } = userOrderState;
  const modalData = isEmptyObject(contentData) && modifyData(contentData, deepLinkStoreMode);
  let { modalContent = {}, modalHeaderText = '' } = modalData;
  const {
    SEARCH_ORDER_DATA,
    MENU_URL,
    DISPOSITION_DATA,
    CURRENT_STORE_INFO,
    SCHEDULE_ORDER_TIME_DATA,
    SELECTED_TILE_DATA,
    DISPOSITION_METHOD,
    ADD_TO_CART_CLICK,
    SET_DISPOSITION,
    USER_LOCALIZED,
    SCHEDULE_ORDER_TIME_PRESERVE_TIME,
    SET_FIND_A_KFC_VIEW,
    SET_REDIRECTION_PATH,
  } = START_ORDER_CONSTANTS;
  const {
    DISPOSITION_TYPE: { TYPE_DINE_IN, TYPE_TAKE_WAY, TYPE_DELIVERY, TYPE_CHRISTMAS_ORDERING },
    FIND_OPEN_KFC_TEXT,
    INVALID_QR_TEXT,
    CLOSED_STORE_MODAL_SUBTITLE,
    TAKEAWAY_STORE_CLOSED_TEXT,
    DINE_IN_STORE_CLOSED_TEXT,
    SWITCH_TO_TAKEAWAY_TEXT,
    SWITCH_TO_DINEIN_TEXT,
  } = DISPOSITION_CONSTANTS;
  const dispositionType =
    userOrderState && userOrderState.dispositionStateData && userOrderState.dispositionStateData.dispositionType
      ? userOrderState.dispositionStateData.dispositionType
      : null;
  let selectedDispositionType = '';
  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState.dispositionNew;

  const dispatch = useDispatch();
  const history = useHistory();
  const [storeDisposition, setStoreDisposition] = useState('');
  const [storeErrorPopupObj, setStoreErrorPopupObj] = useState({
    showError: false,
    errMsg: '',
    errDesc: null,
    buttonText: '',
    buttonCTA: null,
  });
  const { cartData = {}, qrCodeScanTime } = useSelector(state => state.cartReducer);
  const tenantReducer = useSelector(state => state.tenantReducer);
  const { tenantId, disableOrderTypeAnalytic } = tenantReducer;
  const { customerId = '' } = useSelector(state => state.profileReducer);
  let userParams = useSelector(data => data.appStateReducer.userStatus);
  const {
    storesWithStatus = [],
    isStoreStatusLoading,
    selectedStoreDetailsDL = {},
  } = useSelector(data => getValueOrDefaultObject(data.storesReducer));

  const {
    DISPOSITION_ACTION: { SET_QR_DEEPLINK_MODE },
  } = DISPOSITION_CONSTANTS;

  useEffect(() => {
    dispatch(resetStores());
    dispatch(resetStoreDetails());
    dispatch(resetRestaurantDetails());
    checkAndRedirectToHomepage(deepLinkStoreMode, history);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  const findOpenKFCHandler = useCallback(
    (e, shouldSkipCartCheck) => {
      e.stopPropagation();
      const confirmCallBack = () => {
        setStoreErrorPopupObj({
          showError: false,
          errMsg: '',
          errDesc: null,
          buttonText: '',
          buttonCTA: null,
        });
        userOrderStateDispatch({
          type: SET_QR_DEEPLINK_MODE,
          value: { deepLinkStoreMode: false, deeplinkSelectedStoreId: '' },
        });
      };
      checkCartStatus(cartData, userOrderStateDispatch, confirmCallBack, shouldSkipCartCheck);
    },
    [SET_QR_DEEPLINK_MODE, userOrderStateDispatch, cartData],
  );

  useEffect(() => {
    if (deepLinkStoreMode) {
      dispatch(
        getStoreDetails(
          {
            storeId: deeplinkSelectedStoreId,
            tenantId,
          },
          null,
          () => {
            setStoreErrorPopupObj({
              showError: true,
              errMsg: translateWithI18Next(INVALID_QR_TEXT),
              errDesc: null,
              buttonText: translateWithI18Next(FIND_OPEN_KFC_TEXT),
              buttonCTA: e => findOpenKFCHandler(e, false),
            });
          },
        ),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FIND_OPEN_KFC_TEXT, INVALID_QR_TEXT, deepLinkStoreMode, deeplinkSelectedStoreId, dispatch, tenantId]);

  /**
   * @desc Submit handler for disposition form: pickup, delivery, etc.
   * @param {Event} event
   * @param {*} type - defineds what type or order user has selected
   * @param {Boolean} shouldSkipCartCheck
   * @param {DISPOSITION_TYPES} dispositionTypeContent - the direct value of `dispositionType` from contentful
   */

  const onDispositionMethodSubmit = (event, type, shouldSkipCartCheck, dispositionTypeContent) => {
    event.stopPropagation();
    event.preventDefault();
    const selectedDisposition = type.split('-');
    selectedDispositionType = selectedDisposition[selectedDisposition.length - 1].trim();
    if (selectedDispositionType.toLowerCase().indexOf('dine') !== -1) {
      selectedDispositionType = TYPE_DINE_IN;
    }
    if (dispositionTypeContent) {
      selectedDispositionType = dispositionTypeContent;
    }

    setAnalyticsData({ selectedDispositionType });

    if (deepLinkStoreMode) {
      const statusCallPayload = {
        data: [
          { storeId: deeplinkSelectedStoreId, channel: ChannelManager.channel, service: PICK_UP },
          { storeId: deeplinkSelectedStoreId, channel: ChannelManager.channel, service: DINE_IN },
        ],
        store: [
          { ...selectedStoreDetailsDL, service: PICK_UP },
          { ...selectedStoreDetailsDL, service: DINE_IN },
        ],
        tenantId: tenantId,
        setStatusFlag: false,
        isFavoritePage: false,
      };
      const confirmCallBack = () => {
        setStoreDisposition(selectedDispositionType);
        dispatch(getBulkStoreStatus(statusCallPayload));
        userOrderStateDispatch({
          type: DISPOSITION_METHOD,
          value: { dispositionType: selectedDispositionType },
        });
      };
      checkCartStatus(cartData, userOrderStateDispatch, confirmCallBack, shouldSkipCartCheck);
    } else if (
      [TYPE_DINE_IN, TYPE_TAKE_WAY, TYPE_DELIVERY, TYPE_CHRISTMAS_ORDERING].includes(
        selectedDispositionType.toUpperCase(),
      )
    ) {
      userOrderStateDispatch({ type: SET_FIND_A_KFC_VIEW, value: { findAKFC: false } });
      userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: true, configSearchScreen: FORM } });
      localStorage.setItem(LOCAL_STORAGE_KEYS.CONFIG_SEARCH_SCREEN, FORM);
      userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: false } });
      userOrderStateDispatch({
        type: DISPOSITION_METHOD,
        value: { dispositionType: selectedDispositionType },
      });
    } else {
      /* DO NOTHING */
    }
    //call RENDEV-5573 function here
    const { localized = false, loggedIn = false } = userParams;
    const userType = getUserType(localized, loggedIn);
    const payload = {
      '%event%': 'selectOrderType',
      '%disposition%': selectedDispositionType,
      '%userType%': userType,
    };
    orderTypeAnalyticsHandler(payload, disableOrderTypeAnalytic);
  };

  /* redirect to menu page function */
  const gotoMenuPage = (storeObj, dateTimeObjPayload) => {
    let store = storeObj ? storeObj : null;
    userOrderStateDispatch({ value: { selectedData: {} }, type: SELECTED_TILE_DATA });
    localStorage.setItem('currentStoreInfo', JSON.stringify(store));
    userOrderStateDispatch({
      value: store,
      type: CURRENT_STORE_INFO,
    });
    dispatch(
      setUserParams({
        ...userParams,
        localized: true,
      }),
    );
    userOrderStateDispatch({
      value: { selectedDateTime: dateTimeObjPayload },
      type: SCHEDULE_ORDER_TIME_DATA,
    });

    userOrderStateDispatch({
      type: SCHEDULE_ORDER_TIME_PRESERVE_TIME,
      value: { selectContentTime: 'ASAP' },
    });

    userOrderStateDispatch({
      type: SET_QR_DEEPLINK_MODE,
      value: { deepLinkStoreMode: false, deeplinkSelectedStoreId: '' },
    });

    localStorage.setItem('selectedTile', JSON.stringify({}));
    localStorage.setItem('dispositionType', dispositionType);
    localStorage.setItem('tenantReducer', JSON.stringify(tenantReducer));
    localStorage.setItem('dateTimeOrder', JSON.stringify(dateTimeObjPayload));
    localStorage.setItem('storeInfo', JSON.stringify(store));
    localStorage.setItem('savedTimeOrder', 'ASAP');
    history.push({
      pathname: `${MENU_URL}`,
    });
  };

  const checkNegativeScenarios = selectedDispositionTypeDL => {
    if (selectedDispositionTypeDL?.toUpperCase() === TYPE_DINE_IN) {
      setStoreErrorPopupObj({
        showError: true,
        errMsg: translateWithI18Next(DINE_IN_STORE_CLOSED_TEXT),
        errDesc: null,
        buttonText: translateWithI18Next(SWITCH_TO_TAKEAWAY_TEXT),
        buttonCTA: e => onDispositionMethodSubmit(e, TAKEAWAY_TEXT, true),
      });
    } else if (selectedDispositionTypeDL?.toUpperCase() === TYPE_TAKE_WAY) {
      setStoreErrorPopupObj({
        showError: true,
        errMsg: translateWithI18Next(TAKEAWAY_STORE_CLOSED_TEXT),
        errDesc: null,
        buttonText: translateWithI18Next(SWITCH_TO_DINEIN_TEXT),
        buttonCTA: e => onDispositionMethodSubmit(e, DINE_IN_TEXT, true),
      });
    }
  };

  const filterEligibleStoresResponse = async (storesList, selectedDispositionTypeDL) => {
    const eligibleStores = storesList.filter(storeItem => {
      return storeItem?.service === getDispositionTypeOnAPIFormat(selectedDispositionTypeDL);
    });
    if (eligibleStores?.length) {
      const dateTimeObjPayload = {
        time: 'ASAP',
        interval: eligibleStores?.[0].summary.timings.scheduled.periods[0]?.interval,
        date: new Date(),
        selectedTime: 'ASAP',
      };
      //We create a new basket everytime we come via QR code, even if the old and current disposition details and store details are same
      const basketPayloadData = await getBasketPayloadforQROrder(
        dispatch,
        true,
        qrCodeScanTime,
        eligibleStores?.[0],
        getDispositionTypeOnAPIFormat(selectedDispositionTypeDL),
        customerId,
        dateTimeObjPayload,
      );
      dispatch(createBasketsAction({ data: basketPayloadData, tenantId }));

      userOrderStateDispatch({
        type: SET_DISPOSITION,
        value: {
          oldvalue: dispositionNew,
          newValue: {
            store: eligibleStores?.[0],
            time: dateTimeObjPayload.time,
            date: dateTimeObjPayload.date,
            type: selectedDispositionTypeDL,
            interval: dateTimeObjPayload.interval,
            deliveryAddress: userOrderState?.scheduleOrderData?.deliveryAddress,
            selectedTime: dateTimeObjPayload.selectedTime,
          },
        },
      });
      localStorage.setItem('dispositionOld', JSON.stringify(dispositionNew));
      localStorage.setItem(
        'dispositionNew',
        JSON.stringify({
          type: selectedDispositionTypeDL,
          store: eligibleStores?.[0],
          date: dateTimeObjPayload.date,
          time: dateTimeObjPayload.time,
          selectedTime: dateTimeObjPayload.selectedTime,
          interval: dateTimeObjPayload.interval,
          deliveryAddress: userOrderState?.scheduleOrderData?.deliveryAddress,
        }),
      );
      manipulateAlreadySearchedLocations(
        eligibleStores?.[0]?.addresses?.[0]?.address?.addressLines?.[0],
        SEARCH_STORE_CONSTANTS.ALREADY_SERACHED_LOCATIONS,
      );
      setSearchedAttributes();
      const payload = {
        storeID: eligibleStores?.[0]?.id,
        disposition: selectedDispositionTypeDL,
        postCode: eligibleStores?.[0]?.addresses[0]?.address?.pinCode,
      };
      setLocalisationFinishAnalyticsData(payload);
      userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showSearchStore: false } });
      userOrderStateDispatch({
        type: USER_LOCALIZED,
        value: { isLocalized: true },
      });
      gotoMenuPage(eligibleStores?.[0], dateTimeObjPayload);
    } else {
      checkNegativeScenarios(selectedDispositionTypeDL);
    }
  };

  const checkErrorScenarios = (eligibleStores, storeName) => {
    if (!eligibleStores?.length) {
      setStoreErrorPopupObj({
        showError: true,
        errMsg: `${translateWithI18Next(SORRY)} ${storeName} ${translateWithI18Next(CURRENTLY_CLOSED)}`,
        errDesc: translateWithI18Next(CLOSED_STORE_MODAL_SUBTITLE),
        buttonText: translateWithI18Next(FIND_OPEN_KFC_TEXT),
        buttonCTA: e => findOpenKFCHandler(e, true),
      });
    } else {
      filterEligibleStoresResponse(eligibleStores, dispositionType);
    }
  };

  useEffect(() => {
    if (storesWithStatus.length > 0 && !isStoreStatusLoading && storeDisposition && deepLinkStoreMode) {
      const eligibleStores = storesWithStatus?.filter(storeItem => {
        return (
          storeItem?.id &&
          storeItem?.location?.latitude &&
          storeItem?.location?.longitude &&
          storeItem?.summary?.status?.currentStatus === 'OPEN' &&
          storeItem?.summary?.menu?.catalogs?.length &&
          storeItem?.summary?.timings?.operatingHours?.length > 0 &&
          storeItem?.summary?.timings?.asap?.isAvailable
        );
      });
      const storeName = storesWithStatus?.[0]?.name?.[0]?.value;
      checkErrorScenarios(eligibleStores, storeName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storesWithStatus, isStoreStatusLoading, deepLinkStoreMode]);

  /**
   *
   * @param {*} element - method to handle close of the modal
   */
  const handleClose = event => {
    event.stopPropagation();
    event.preventDefault();
    localStorage.setItem('renderComp', true);
    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: false } });
    userOrderStateDispatch({
      type: ADD_TO_CART_CLICK,
      value: { addToCart: false },
    });
    userOrderStateDispatch({
      type: SET_QR_DEEPLINK_MODE,
      value: { deepLinkStoreMode: false, deeplinkSelectedStoreId: '' },
    });
    userOrderStateDispatch({ type: SET_REDIRECTION_PATH, value: { redirectionOrder: '' } });
    userOrderStateDispatch({
      type: SET_FIND_A_KFC_VIEW,
      value: { findAKFC: window.location.pathname === ROUTE_URL.FIND_STORE },
    });
    isDeepLinkURL && goToMenuPage(history);
  };

  useEffect(() => {
    const closeDispositionModal = eventofDispositionModal => {
      if (eventofDispositionModal.keyCode === 27) {
        handleClose(eventofDispositionModal);
      }
    };
    window.addEventListener('keydown', closeDispositionModal);
    return () => window.removeEventListener('keydown', closeDispositionModal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispositionModuleForm = (
    <DispositionModuleForm modalContent={modalContent} onDispositionMethodSubmit={onDispositionMethodSubmit} />
  );
  const renderElement = (
    <DispositionModuleInsideModal
      handleClose={handleClose}
      DispositionModuleForm={dispositionModuleForm}
      headerText={modalHeaderText}
      modalTitleId='dispostion_selector'
    />
  );
  return (
    <>
      {storeErrorPopupObj?.showError && (
        <AlertFormInsideModel
          handleClose={null}
          CartAlertForm={
            <AlertForm
              title={storeErrorPopupObj?.errMsg}
              contentMsg={storeErrorPopupObj?.errDesc}
              confirmButtonText={storeErrorPopupObj?.buttonText}
              confirmHandler={storeErrorPopupObj?.buttonCTA}
              buttonContainerClass='deeplink-alert-btn-container'
            />
          }
        />
      )}
      {renderElement}
    </>
  );
};

export default DispositionModule;
